module.exports = __webpack_public_path__ + "media/assets/images/flags/au-6cdea16d35d07b5967fdcd1332986bbe.svg";